module.exports = __webpack_public_path__ + "media/icons/arrow-aea7f9b6.png";